export default function setPageKeys(pageKeys) {
  window.pageKeys = pageKeys;
  console.log('pk', window.pageKeys);
}
